<template>
    <div>
        <kgr-dropdown
            display="name"
            :label="label"
            :value="value"
            :options="categories"
            :loading="loading"
            :inline="inline"
            @post-input="onInput"
        />
    </div>
</template>

<script>
import ClubFeeCategory from '../../../../js/dto/ClubFeeCategory';
import ClubFeeCategoryRepository from '../../../../js/repository/ClubFeeCategoryRepository.js';
import Dropdown from './Dropdown.vue';

export default {
    components: {
        'kgr-dropdown': Dropdown,
    },
    props: {
        clubId: {
            type: Number,
            required: true,
        },
        value: {
            type: ClubFeeCategory,
            default: () => null,
        },
        hideLabel: {
            type: Boolean,
            required: false,
            default: false,
        },
        inline: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    data() {
        return {
            loading: true,
            categories: [],
        };
    },
    computed: {
        label() {
            return this.hideLabel ? null : this.$t('clubFee');
        },
    },
    created() {
        this.reload();
    },
    methods: {
        reload() {
            ClubFeeCategoryRepository
                .findByClubId(this.clubId)
                .then((data) => {
                    this.loading = false;
                    this.categories = data;
                })
                .catch(() => this.$notify.error('error.loadingData'));
        },
        onInput(value) {
            this.$emit('input', value);
            this.$nextTick(() => {
                this.$emit('post-input', value);
            });
        },
    },
};
</script>
